import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge, mergeConfigs } from 'tailwind-merge'

import { tailwindMergeConfig } from '@orus.eu/design-tokens/output/tailwind-merge.config'

/**
 * The semantic spacing names live in `src/styles/_shared-theme.css`, not in
 * `@orus.eu/design-tokens`, so the generated config cannot know them. They ride
 * the Tailwind `--spacing-*` namespace, hence the `spacing` theme key: it covers
 * every spacing-driven group (`p*`, `m*`, `gap*`, `space-*`, `inset*`, sizes…) at
 * once, and extends rather than overrides so `p-50` keeps merging with `p-card`.
 */
const semanticSpacing = { extend: { theme: { spacing: ['inline', 'stack', 'card', 'page', 'section'] } } }

/**
 * `cn()` merges Tailwind class lists while resolving conflicts against the
 * Orus utility surface defined in `@orus.eu/design-tokens`. The merge config
 * is generated from the same tokens that emit `output/tailwind.css`, so a new
 * Orus token is automatically recognized after running
 * `turbo run generate --filter=@orus.eu/design-tokens`.
 */
const twMerge = extendTailwindMerge(tailwindMergeConfig, (config) => mergeConfigs(config, semanticSpacing))

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
